import api from './api';

export const fetchChatRooms = () => api.get('/chat/rooms/');

export const fetchRoomMessages = (roomId, params = {}) =>
  api.get(`/chat/rooms/${roomId}/messages/`, { params });

export const sendRoomMessage = (roomId, payload) => {
  const isFormData = payload instanceof FormData;
  const data = isFormData ? payload : new FormData();

  if (!isFormData) {
    if (payload.content) {
      data.append('content', payload.content);
    }
    if (payload.mentions) {
      payload.mentions.forEach((id) => data.append('mentions[]', id));
    }
    (payload.attachments || []).forEach((file) => data.append('attachments', file));
  }

  return api.post(`/chat/rooms/${roomId}/messages/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const markRoomAsRead = (roomId) =>
  api.post(`/chat/rooms/${roomId}/mark-read/`);

export const toggleRoomMute = (roomId, mute) =>
  api.post(`/chat/rooms/${roomId}/toggle-mute/`, { mute });

export const fetchRoomMembers = (roomId) =>
  api.get(`/chat/rooms/${roomId}/members/`);

export const fetchChatUserSettings = () =>
  api.get('/chat/user-settings/');

export const updateChatUserSettings = (data) =>
  api.put('/chat/user-settings/', data);

export const fetchNotificationSettings = () =>
  api.get('/chat/notification-settings/');

export const fetchUnreadSummary = () =>
  api.get('/chat/unread/');

export const updateRoomMessage = (roomId, messageId, payload) => {
  const isFormData = payload instanceof FormData;
  const data = isFormData ? payload : new FormData();

  if (!isFormData) {
    Object.entries(payload || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (Array.isArray(value)) {
        value.forEach((item) => data.append(`${key}[]`, item));
      } else {
        data.append(key, value);
      }
    });
  }

  return api.patch(`/chat/rooms/${roomId}/messages/${messageId}/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteRoomMessage = (roomId, messageId) =>
  api.delete(`/chat/rooms/${roomId}/messages/${messageId}/`);

export const addReaction = (roomId, messageId, emoji) =>
  api.post(`/chat/rooms/${roomId}/messages/${messageId}/add-reaction/`, { emoji });

export const removeReaction = (roomId, messageId, emoji) =>
  api.post(`/chat/rooms/${roomId}/messages/${messageId}/remove-reaction/`, { emoji });

export const pinMessage = (roomId, messageId) =>
  api.post(`/chat/rooms/${roomId}/messages/${messageId}/pin/`);

export const unpinMessage = (roomId, messageId) => {
  const payload = messageId ? { message_id: messageId } : {};
  return api.post(`/chat/rooms/${roomId}/messages/unpin/`, payload);
};

export const fetchRoomPins = (roomId) => api.get(`/chat/rooms/${roomId}/pins/`);

export const searchChatUsers = (params = {}) =>
  api.get('/chat/users/', { params });

export const startDirectChat = (userId) =>
  api.post('/chat/direct/', { user_id: userId });

export default {
  fetchChatRooms,
  fetchRoomMessages,
  sendRoomMessage,
  markRoomAsRead,
  toggleRoomMute,
  fetchRoomMembers,
  fetchChatUserSettings,
  updateChatUserSettings,
  fetchNotificationSettings,
  fetchUnreadSummary,
  updateRoomMessage,
  deleteRoomMessage,
  addReaction,
  removeReaction,
  pinMessage,
  unpinMessage,
  fetchRoomPins,
  searchChatUsers,
  startDirectChat,
};
